<template>
  <div>
    <div class="logo">
      <a href="#" @click.prevent="openSidebarLink('home')" v-scroll-to="'#home'"
        ><img :src="require('@/assets/images/logo2.png')" alt="OpenCabana"
      /></a>
      <!-- <a href="" @click.prevent="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container">
        <i class="fa fa-times"></i>
      </a> -->
    </div>

    <!-- <div v-if="!sidebar.opened" class="logo">
      <a href="" @click.prevent="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container">
        <i class="fa fa-bars"></i>
      </a>
    </div> -->

    <div class="sidebar-menu-wrapper no-print">
      <!-- <ul class="sidebar-menu icons">
        <li class="sidebar-menu-item" v-if="!isLoggedIn">
          <a href="" @click.prevent="openSidebarLink('login')"><i class="fa fa-sign-in"></i></a>
        </li>
        <li class="sidebar-menu-item" v-if="isLoggedIn">
          <a href="" @click.prevent="openSidebarLink('dashboard')"><i class="fa fa-user"></i><span>{{ userName }}</span></a>
        </li>
        <li class="sidebar-menu-item" v-if="isLoggedIn">
          <a href="" @click.prevent="logout"><i class="fa fa-sign-out"></i></a>
        </li>
      </ul> -->
      <!-- <li class="sidebar-menu-item">
        <a href="" @click.prevent="openSidebarLink('locations')">LOCATIONS</a>
      </li> -->
      <!-- <li class="sidebar-menu-item">
        <a href="" @click.prevent="openSidebarLink('hotel-partners')">Hotel Partners</a>
      </li> -->

      <ul class="sidebar-menu">
        <!-- <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('home')">HOME</a>
        </li> -->
        <!--
        <li class="sidebar-menu-item">
          <a
            href="#"
            @click.prevent="openSidebarLink('home')"
            v-scroll-to="'#features'"
            >FEATURES & BENEFITS</a>
        </li>
        -->
        <!-- <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('home')">ACTIONABLE DATA</a>
        </li>
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('locations')">RESERVATION CALENDAR</a>
        </li> -->
        <!--
        <li class="sidebar-menu-item">
          <a
            href="#"
            @click.prevent="openSidebarLink('home')"
            v-scroll-to="'#contact_us'"
            >CONTACT US</a
          >
          <!-- <a href="" @click.prevent="openSidebarLink('pages/contact')">CONTACT US</a>
        </li>-->
        <!--
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('pages/terms')"
            >TERMS OF USE</a>
        </li>
        <li class="sidebar-menu-item">
          <a href="" @click.prevent="openSidebarLink('pages/privacy')"
            >PRIVACY</a>
        </li>
        -->
      </ul>

      <ul class="sidebar-menu">
        <li class="sidebar-menu-item">
          <el-button
            v-if="routeName !== 'LocationList'"
            type="primary"
            round
            @click.prevent="openSidebarLink('locations')"
            >BOOK A CABANA</el-button
          >
          <el-button v-if="routeName !== 'home'" type="warning" round @click.prevent="openSidebarLink('home')">Become a Hotel Partner</el-button>
        </li>
      </ul>

      <div class="bottom-area text-center">
        <ul class="sidebar-menu">
          <li v-if="!isLoggedIn" class="sidebar-menu-item">
            <a href="" @click.prevent="openSidebarLink('login')">GUEST LOGIN</a>
          </li>
          <li v-if="isLoggedIn" class="sidebar-menu-item">
            <a href="" @click.prevent="logout">LOGOUT</a>
          </li>
        </ul>
        <!-- <hr class="space xs" /> -->
        <!-- <div class="social-group">
              <a target="_blank" href="https://www.facebook.com/opencabana/"><i class="fa fa-facebook"></i></a>
              <a target="_blank" href="https://www.twitter.com/opencabana/"><i class="fa fa-twitter"></i></a>
              <a target="_blank" href="https://www.instagram.com/opencabana/"><i class="fa fa-instagram"></i></a>
              <a target="_blank" href="https://www.youtube.com/channel/UC4guebgvIj1sTBwV4Da3tjg/"><i class="fa fa-youtube"></i></a>
          </div>
          <p>&copy; {{ date }} - All rights reserved.</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Hamburger from "@/components/Hamburger";
import moment from "moment";
export default {
  data() {
    return {
      date: moment(new Date()).format("YYYY"),
    };
  },
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },
    openSidebarLink(page) {
      // this.$store.dispatch('closeSideBar', { withoutAnimation: false })
      // this.$store.dispatch('toggleSideBar')
      if (page === "home") {
        this.$router.push("/home");
      } else {
        this.$router.push("/" + page);
      }
    },
    logout() {
      this.$store.dispatch("user/Logout").then(() => {
        this.$router.push("/home");
        location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-menu-wrapper {
  display: flex;
  align-content: center;
  .sidebar-menu {
    display: flex;
    margin: unset;
    .sidebar-menu-item {
      margin-left: 15px;
      display: flex;
      align-items: center;
    }
  }
  .bottom-area{
    margin-left: 25px;
    .sidebar-menu {
    display: flex;
    margin: unset;
    padding: 0;
    .sidebar-menu-item {
      display: flex;
      align-items: center;
      width: 150px;
      margin: unset;

    }
  }
  }
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue?4d697135